function SolutionsComparison() {
  return (
    <div className="relative w-full max-w-4xl mx-auto">
      <img
        src="/legal-solutions-comparison.jpg"
        alt="Legal AI Solutions Comparison: Traditional Tools, General AI, Enterprise Legal AI, and SafeIdea - showing that only SafeIdea delivers Security, Capability, and Affordability"
        className="w-full h-auto rounded-lg shadow-xl"
      />
    </div>
  );
}

export function TheProblem() {
  return (
    <section id="the-problem" className="py-20 sm:py-32 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mb-12">
          <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl mb-6">
            The Legal AI Dilemma
          </h2>
          <p className="text-xl text-gray-700">
            Every existing solution <strong>fails at something critical</strong>.
          </p>
          <p className="text-xl text-teal-600 font-semibold mt-2">
            Only SafeIdea delivers all three essentials.
          </p>
        </div>

        {/* Centered image */}
        <div className="mx-auto max-w-5xl">
          <SolutionsComparison />
        </div>
      </div>
    </section>
  );
}
